//@vendors
import { isMobile } from 'utilities/browser';

const React = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const { Component } = require('react');
import { withRouter, Prompt } from 'react-router-dom';
import { history } from 'routes/history';
// @ commons
import { formatText } from 'core/i18n';
// @ utilities
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
// @ components
const { StepsContent } = require('components/steps/stepsContent');
const Header = require('components/header/header').Header;
const Iban = require('components/newAccountSteps/profileSteps/iban');
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
// @ actions
const stepsActions = require('actions/stepsActions');
const logActions = require('actions/logActions');
const ibanActions = require('actions/ibanActions');
import { ALLOW_COOKIE } from 'constants/index';
const { ROBO, GBI, CREDIT_CARD, TRADITIONAL } = require('constants/userProfile');
import { ONB_BANK_DEPOSIT_OPEN } from 'constants/onboardingTypes';
import { BASE_PATH } from 'constants/index';
import withFeatureToggling from '../../hocs/withFeatureToggling/withFeatureToggling';
import { START } from 'constants/video/status';
import { VIDEOSELFIE_CAPTURE } from 'constants/featureFlagging';
import { deleteCookie } from 'utilities/logoutHelper';
import SessionTimeOut from 'components/sessionTimeOut/SessionTimeOut';

class StepsView extends Component {
    constructor(props) {
        super(props);
        this.routerWillLeave = this.routerWillLeave.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { userProfile, immStepsState, stepsActions } = this.props;
        const iban = userProfile.iban;
        const wizardSelected = immStepsState.get('wizardSelected');
        if (typeof iban === 'undefined') {
            history.push(BASE_PATH);
        }
        if (
            userProfile.investmentType === TRADITIONAL &&
            userProfile.onboardingType === ONB_BANK_DEPOSIT_OPEN &&
            !userProfile.isJointHolder &&
            wizardSelected !== 'depositSteps'
        ) {
            stepsActions.selectDepositSteps();
        }

        if (
            userProfile.jointHolderType === 'autorizado' &&
            userProfile.isJointHolderNoClient &&
            wizardSelected !== 'authorizedSteps'
        ) {
            stepsActions.selectAuthorizedSteps();
        }

        if (userProfile.jointHolderData && !userProfile.isJointHolderNoClient && wizardSelected !== 'clientSteps') {
            stepsActions.selectClientSteps();
            stepsActions.changeMinFinalizeStep({ index: 0 });
        }

        if (userProfile.withConfigCard && wizardSelected !== 'configCardSteps') {
            stepsActions.selectConfigCardSteps();
        }

        if (userProfile.investmentType === ROBO && wizardSelected !== 'roboSteps') {
            stepsActions.selectRoboSteps();
            stepsActions.changeMinFinalizeStep({ index: 3 });
        }

        if (userProfile.investmentType === GBI && wizardSelected !== 'gbiSteps') {
            stepsActions.selectGbiSteps();
            stepsActions.changeMinFinalizeStep({ index: 4 });
        }
    }

    componentDidMount() {
        return <Prompt message={this.routerWillLeave} />;
    }

    routerWillLeave(nextLocation) {
        const { immStepsState, stepsActions } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const steps = immStepsState.get('steps');
        const currentStep = steps.get(currentIndex);
        const pathName = nextLocation.pathname;
        let confirmation = false;
        if (
            nextLocation.pathname !== '/' &&
            !pathName.startsWith('/login') &&
            nextLocation.pathname !== '/hazte-cliente' &&
            !pathName.startsWith('/hazte-cliente/login')
        ) {
            return true;
        }
        if (!currentStep.get('finished')) {
            confirmation = window.confirm(formatText('leaveStep-text'));
            if (confirmation) {
                stepsActions.resetStore();

                if (ALLOW_COOKIE) {
                    deleteCookie();
                }
            }
        }

        return confirmation;
    }

    renderSessionTimeout() {
        if (__ENV__ === 'LOCAL') {
            return null;
        }

        return <SessionTimeOut />;
    }

    shouldRemoveBottomMargin() {
        return (
            isMobile() && this.props.userProfile.identityStatus === START && this.props.flags.get(VIDEOSELFIE_CAPTURE)
        );
    }

    render() {
        const { userProfile, closeIban } = this.props;
        const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(userProfile.investmentType);

        return typeof userProfile.iban !== 'undefined' ? (
            <div className={`prospects-content ${this.shouldRemoveBottomMargin() && 'remove-margin'}`}>
                <Header showContinueProcess={false} />
                {this.renderSessionTimeout()}
                <ConditionalToggling condition={!userInvestmentType[CREDIT_CARD]}>
                    <Iban userProfile={userProfile} close={closeIban} />
                </ConditionalToggling>
                <div className="prospects-step-content">
                    <StepsContent />
                </div>
            </div>
        ) : null;
    }
}

module.exports.constructor = StepsView;
module.exports.StepsView = withRouter(
    withFeatureToggling(
        connect(
            state => ({
                userProfile: state.userProfile,
                immStepsState: state.steps,
            }),
            dispatch => ({
                closeIban: () => dispatch(ibanActions.toggleShowIban.call(undefined, false)),
                stepsActions: bindActionCreators(stepsActions, dispatch),
                logActions: bindActionCreators(logActions, dispatch),
            })
        )(StepsView)
    )
);
